// src/Views/HomePage.js
import { useEffect, useState } from "react";
import "./HomePage.css";
import useDevice from "../hooks/useDevice"; // Custom hook to detect device type (mobile/desktop)
import Header from "./Header";
import Mobile from "./Mobile";

const HomePage = () => {
  const [lockedMobile, setLockedMobile] = useState(false);
  const { isMobile } = useDevice();

  useEffect(() => {
    if (isMobile) {
      setLockedMobile(true);
    }
  }, [isMobile]);

  if (lockedMobile) {
    return (
      <div className="cafe-homepage">
        <Mobile />
      </div>
    );
  }

  return (
    <div className="cafe-homepage">
      <Header />
    </div>
  );
};

export default HomePage;
